"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRestDepartmentAttachment = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var IkeRestDepartmentAttachment = /** @class */ (function () {
    function IkeRestDepartmentAttachment(boundDepartment) {
        this.boundDepartment = boundDepartment;
    }
    IkeRestDepartmentAttachment.prototype.set = function (fileName, buffer, contentType) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var core, headers, body, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        core = this.boundDepartment.boundUser.core;
                        headers = core.headers(this.boundDepartment.boundUser.accessToken, this.boundDepartment.departmentId);
                        headers[core_api_1.IkeRequestHeader.FILE_NAME] = fileName;
                        headers[core_api_1.IkeRequestHeader.CONTENT_TYPE] = contentType;
                        body = typeof buffer === 'string' ? new TextEncoder().encode(buffer) : new Uint8Array(buffer);
                        return [4 /*yield*/, core.fetch(core.path("/v1/action/attachment.create"), { method: 'POST', body: body, headers: headers })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, core.validateIsJson(response)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, response.json()];
                    case 3: return [2 /*return*/, core.handleError(response)];
                }
            });
        });
    };
    IkeRestDepartmentAttachment.prototype.get = function (attachmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var core, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        core = this.boundDepartment.boundUser.core;
                        return [4 /*yield*/, core.actionRaw('attachment.data', { attachmentId: attachmentId }, this.boundDepartment.boundUser.accessToken, this.boundDepartment.departmentId)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            return [2 /*return*/, response.body];
                        }
                        return [2 /*return*/, core.handleError(response)];
                }
            });
        });
    };
    IkeRestDepartmentAttachment.prototype.info = function (attachmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.boundDepartment.action('attachment.get', { attachmentId: attachmentId })];
            });
        });
    };
    IkeRestDepartmentAttachment.prototype.parse = function (attachmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var core, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        core = this.boundDepartment.boundUser.core;
                        return [4 /*yield*/, core.actionRaw('attachment.parse', { attachmentId: attachmentId }, this.boundDepartment.boundUser.accessToken, this.boundDepartment.departmentId)];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, core.validateIsJson(response)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, response.json()];
                    case 3: return [2 /*return*/, core.handleError(response)];
                }
            });
        });
    };
    IkeRestDepartmentAttachment.prototype.antivirusScan = function (attachmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var core, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        core = this.boundDepartment.boundUser.core;
                        return [4 /*yield*/, core.actionRaw('attachment.antivirus', { attachmentId: attachmentId }, this.boundDepartment.boundUser.accessToken, this.boundDepartment.departmentId)];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, core.validateIsJson(response)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, response.json()];
                    case 3: return [2 /*return*/, core.handleError(response)];
                }
            });
        });
    };
    return IkeRestDepartmentAttachment;
}());
exports.IkeRestDepartmentAttachment = IkeRestDepartmentAttachment;
//# sourceMappingURL=rest.department.attachment.js.map